import React, { RefObject } from 'react'
import UploadedDocument from '@Components/DocumentUploadForm/UploadedDocumentsList/UploadedDocuments'
import { UnifiedDocument } from '@Entities/document/document-to-upload'

interface UploadedDocumentsListProps {
    uploadedFiles: UnifiedDocument[]
    onDescriptionChange?: (document: UnifiedDocument, description: string, index: number) => void
    descriptionHelpText?: string
    onRemove: (document: UnifiedDocument, index: number) => void
    browseFilePickerRef: RefObject<HTMLInputElement | null>
}

const UploadedDocumentsList = (props: UploadedDocumentsListProps) => (
    <ul>
        {props.uploadedFiles.map((docToUpload, index) => (
            <UploadedDocument key={docToUpload.clientId} {...props} docToUpload={docToUpload} index={index} />
        ))}
    </ul>
)

export default UploadedDocumentsList
